import { mianApiPost } from './http';
// 案例地址
export const apiUserlogin = data => mianApiPost('/login/login.html', data);// 登录接口
export const apiUserinfo = data => mianApiPost('/user/info.html', data);// 获取个人信息
export const apiDepartment = data => mianApiPost('/department/lists.html', data);// 获取部门列表
export const apiRole = data => mianApiPost('/role/lists.html', data);// 获取角色列表
export const apiUsermodify = data => mianApiPost('/user/modify.html', data);// 修改个人信息
export const apiUserlogs = data => mianApiPost('/userlogs/lists.html', data);// 获取登录日志

export const apiUserlists = data => mianApiPost('/user/lists.html', data);// 获取账号列表
export const apiUserall = data => mianApiPost('/user/userall.html', data);// 获取账号列表
export const apiUserdel = data => mianApiPost('/user/del.html', data);// 获取账号列表
export const apiCrmdestroy = data => mianApiPost('/crm/destroy.html', data);// 清除客户数据
export const apiCrmTracedel = data => mianApiPost('/crmtrace/del.html', data);// 清除客户数据
export const apiLogincode = data => mianApiPost('/login/code.html', data);// 清除客户数据

export const apiUserstore = data => mianApiPost('/user/store.html', data);// 添加个人信息
export const apiCrmsavezhuangtai = data => mianApiPost('/crm/savezhuangtai.html', data);// 修改状态
export const apiCrmcontactrepeat = data => mianApiPost('/crm/contactrepeat.html', data);// 修改状态
export const apiCrmblackphonerepeat = data => mianApiPost('/crm/blackrepeat.html', data);// 修改状态

export const apiUsercontrolstore = data => mianApiPost('/usercontrol/store.html', data);// 添加控制
export const apiUsercontrolmodify = data => mianApiPost('/usercontrol/modify.html', data);// 修改控制
export const apiUsercontrol = data => mianApiPost('/usercontrol/lists.html', data);// 控制列表
export const apiUsercontroldel = data => mianApiPost('/usercontrol/del.html', data);// 控制列表
export const apiUsercontrolinfo = data => mianApiPost('/usercontrol/info.html', data);// 控制列表

export const apiRolestore = data => mianApiPost('/role/store.html', data);// 添加角色
export const apiRolemodify = data => mianApiPost('/role/modify.html', data);// 修改角色
export const apiRolelists = data => mianApiPost('/role/alls.html', data);// 角色列表
export const apiRoledel = data => mianApiPost('/role/del.html', data);// 删除角色
export const apiRoleinfo = data => mianApiPost('/role/info.html', data);// 角色详情

export const apiUserlogsalls = data => mianApiPost('/userlogs/alls.html', data);// 角色详情

export const apiUsercolleague = data => mianApiPost('/usercolleague/lists.html', data);// 同事设计
export const apiUsercolleaguemodify = data => mianApiPost('/usercolleague/modify.html', data);// 编辑同事
export const apiUsercolleagueinfo = data => mianApiPost('/usercolleague/info.html', data);// 编辑同事

export const apiTagesalls = data => mianApiPost('/tages/lists.html', data);// crm标签集合
export const apiTagesdel = data => mianApiPost('/tages/del.html', data);// crm标签集合
export const apiTagesmodify = data => mianApiPost('/tages/modify.html', data);// crm标签集合
export const apiTagesstore = data => mianApiPost('/tages/store.html', data);// crm标签集合
export const apiTagesinfo = data => mianApiPost('/tages/info.html', data);// crm标签集合

export const apiResumetagesalls = data => mianApiPost('/resumetages/lists.html', data);// crm标签集合
export const apiResumetagesdel = data => mianApiPost('/resumetages/del.html', data);// crm标签集合
export const apiResumetagesmodify = data => mianApiPost('/resumetages/modify.html', data);// crm标签集合
export const apiResumetagesstore = data => mianApiPost('/resumetages/store.html', data);// crm标签集合
export const apiResumetagesinfo = data => mianApiPost('/resumetages/info.html', data);// crm标签集合

export const apiResumetagesArr = data => mianApiPost('/resumetages/alls.html', data);// crm标签集合
export const apiResumepositionArr = data => mianApiPost('/resumelist/position.html', data);// crm标签集合
export const apiResumelist = data => mianApiPost('/resumelist/lists.html', data);// crm标签集合
export const apiResumeliststore = data => mianApiPost('/resumelist/store.html', data);// crm标签集合
export const apiResumelistmodify = data => mianApiPost('/resumelist/modify.html', data);// crm标签集合
export const apiResumelistinfo = data => mianApiPost('/resumelist/info.html', data);// crm标签集合
export const apiResumeRefreshlist = data => mianApiPost('/resumelist/refreshlist.html', data);// 更新队列
export const apiResumelistdel = data => mianApiPost('/resumelist/del.html', data);// crm标签集合

export const apiResumeinterview = data => mianApiPost('/resumeinterview/lists.html', data);// crm标签集合
export const apiResumeinterviewstore = data => mianApiPost('/resumeinterview/store.html', data);// crm标签集合
export const apiResumeinterviewdel = data => mianApiPost('/resumeinterview/del.html', data);// crm标签集合

export const apiResumetrace = data => mianApiPost('/resumetrace/lists.html', data);// crm标签集合
export const apiResumetracestore = data => mianApiPost('/resumetrace/store.html', data);// crm标签集合
export const apiResumeworktable = data => mianApiPost('/resumeinterview/worktable.html', data);// crm标签集合
export const apiResumeinterviewrefreshlist = data => mianApiPost('/resumeinterview/refreshlist.html', data);// crm标签集合

export const apiSignevent = data => mianApiPost('/signevent/lists.html', data);// crm标签集合
export const apiSigneventusers = data => mianApiPost('/signevent/users.html', data);// crm标签集合
export const apiSigneventstore = data => mianApiPost('/signevent/store.html', data);// crm标签集合
export const apiSigneventdel = data => mianApiPost('/signevent/del.html', data);// crm标签集合
export const apiSigneventinfo = data => mianApiPost('/signevent/info.html', data);// crm标签集合
export const apiSigneventmodify = data => mianApiPost('/signevent/modify.html', data);// crm标签集合
export const apiSignlog = data => mianApiPost('/signlog/lists.html', data);// crm标签集合
export const apiSignloginfo = data => mianApiPost('/signlog/info.html', data);// crm标签集合
export const apiSigneventjoinlist = data => mianApiPost('/signlog/joinlist.html', data);// crm标签集合
export const apiSignloggenjinren = data => mianApiPost('/signlog/genjinren.html', data);// crm标签集合

// 公告
export const apiUsernotice = data => mianApiPost('/usernotice/lists.html', data);// crm标签集合
export const apiUsernoticestore = data => mianApiPost('/usernotice/store.html', data);// crm标签集合
export const apiUsernoticeinfo = data => mianApiPost('/usernotice/info.html', data);// crm标签集合
export const apiUsernoticemodify = data => mianApiPost('/usernotice/modify.html', data);// crm标签集合
export const apiUsernoticedel = data => mianApiPost('/usernotice/del.html', data);// crm标签集合

// 联系人
export const apiUsercontacts = data => mianApiPost('/contacts/lists.html', data);// crm标签集合
export const apiUsercontactsstore = data => mianApiPost('/contacts/store.html', data);// crm标签集合
export const apiUsercontactsinfo = data => mianApiPost('/contacts/info.html', data);// crm标签集合
export const apiUsercontactsmodify = data => mianApiPost('/contacts/modify.html', data);// crm标签集合
export const apiUsercontactsdel = data => mianApiPost('/contacts/del.html', data);// crm标签集合

// 备忘
export const apiMemo = data => mianApiPost('/memo/lists.html', data);// crm标签集合
export const apiMemostore = data => mianApiPost('/memo/store.html', data);// crm标签集合
export const apiMemoinfo = data => mianApiPost('/memo/info.html', data);// crm标签集合
export const apiMemomodify = data => mianApiPost('/memo/modify.html', data);// crm标签集合
export const apiMemodel = data => mianApiPost('/memo/del.html', data);// crm标签集合

// 消息
export const apiMessage = data => mianApiPost('/message/lists.html', data);// crm标签集合
export const apiMessagestate = data => mianApiPost('/message/state.html', data);// crm标签集合

// 客户
export const apiCrmlist = data => mianApiPost('/crm/lists.html', data);// crm标签集合
export const apiCrmlistWeilianxi = data => mianApiPost('/crm/listsweilianxi.html', data);// crm标签集合
export const apiCrmTages = data => mianApiPost('/tages/tagesarr.html', data);// crm标签集合
export const apiCrmLogs = data => mianApiPost('/crmlogs/lists.html', data);// crm标签集合
export const apiCrmInfo = data => mianApiPost('/crm/info.html', data);// 详情

export const apiCrmTrace = data => mianApiPost('/crmtrace/lists.html', data);// 跟进列表
export const apiCrmShoucifenpeiTrace = data => mianApiPost('/crmdatasharenew/lists.html', data);// 跟进列表


export const apiCrmTracestore = data => mianApiPost('/crmtrace/store.html', data);// 跟进列表
export const apiCrmTraceLabel = data => mianApiPost('/tages/label.html', data);// 标签
export const apiUserZaizhi = data => mianApiPost('/user/zaizhi.html', data);// 标签
export const apiCrmModify = data => mianApiPost('/crm/modify.html', data);// 标签
export const apiCrmStore = data => mianApiPost('/crm/store.html', data);// 标签

export const apiCrmContact = data => mianApiPost('/crmcontact/lists.html', data);// 跟进列表
export const apiCrmContactStore = data => mianApiPost('/crmcontact/store.html', data);// 跟进列表
export const apiCrmContactDel = data => mianApiPost('/crmcontact/del.html', data);// 跟进列表

export const apiCrmPact = data => mianApiPost('/crmpact/lists.html', data);// 跟进列表
export const apiCrmPactStore = data => mianApiPost('/crmpact/store.html', data);// 跟进列表
export const apiCrmPactDel = data => mianApiPost('/crmpact/del.html', data);// 跟进列表
export const apiCrmPactInfo = data => mianApiPost('/crmpact/info.html', data);// 跟进列表

export const apiCrmPactTages = data => mianApiPost('/tages/pacttages.html', data);// 跟进列表

export const apiCrmFiles = data => mianApiPost('/crmfiles/lists.html', data);// 跟进列表
export const apiCrmFilesStore = data => mianApiPost('/crmfiles/store.html', data);// 跟进列表
export const apiCrmFilesDel = data => mianApiPost('/crmfiles/del.html', data);// 跟进列表


export const apiCrmFinance = data => mianApiPost('/crmfinance/lists.html', data);// 跟进列表
export const apiCrmFinanceStore = data => mianApiPost('/crmfinance/store.html', data);// 跟进列表
export const apiCrmFinanceDel = data => mianApiPost('/crmfinance/del.html', data);// 跟进列表
export const apiCrmFinanceCatearr = data => mianApiPost('/crmfinance/catearr.html', data);// 跟进列表


export const apiCrmShare = data => mianApiPost('/crm/share.html', data);// 跟进列表
export const apiCrmDutyuid = data => mianApiPost('/crm/dutyuser.html', data);// 跟进列表
export const apiCrmSetchance = data => mianApiPost('/crm/setchance.html', data);// 跟进列表
export const apiCrmRecover = data => mianApiPost('/crm/recover.html', data);// 跟进列表
export const apiCrmSetclient = data => mianApiPost('/crm/setclient.html', data);// 跟进列表
export const apiCrmDel = data => mianApiPost('/crm/del.html', data);// 跟进列表
export const apiCrmBlackapply = data => mianApiPost('/crmblack/apply.html', data);// 跟进列表
export const apiCrmProtect = data => mianApiPost('/crm/protect.html', data);// 跟进列表
export const apiCrmSetlatent = data => mianApiPost('/crm/setlatent.html', data);// 跟进列表

export const apiUpdatetoken = data => mianApiPost('/crm/updatetoken.html', data);// 跟进列表
export const apiBindinginfo = data => mianApiPost('/crm/binding.html', data);// 跟进列表

export const apiCrmblackstore = data => mianApiPost('/crmblack/store.html', data);// 添加角色
export const apiCrmblackmodify = data => mianApiPost('/crmblack/modify.html', data);// 修改角色
export const apiCrmblacklists = data => mianApiPost('/crmblack/lists.html', data);// 角色列表
export const apiCrmblackdel = data => mianApiPost('/crmblack/del.html', data);// 删除角色
export const apiCrmblackinfo = data => mianApiPost('/crmblack/info.html', data);// 角色详情
// 数据统计
export const apiStatisticsvisitmy = data => mianApiPost('/statistics/visitmy.html', data);// crm标签集合
export const apiStatisticsvisitmyline = data => mianApiPost('/statistics/visitmyline.html', data);// crm标签集合
export const apiStatisticsvisitall = data => mianApiPost('/statistics/visitall.html', data);// crm标签集合
export const apiStatisticsvisitallline = data => mianApiPost('/statistics/visitallline.html', data);// crm标签集合
export const apiStatisticshome = data => mianApiPost('/statistics/home.html', data);// crm标签集合

export const apiStatisticscrmchancehome = data => mianApiPost('/statistics/crmchancehome.html', data);// crm标签集合
export const apiStatisticscrmchancedataone = data => mianApiPost('/statistics/crmchancedataone.html', data);// crm标签集合
export const apiStatisticscrmchancedatatow = data => mianApiPost('/statistics/crmchancedatatow.html', data);// crm标签集合

export const apiStatisticscrmdataone = data => mianApiPost('/statistics/crmdataone.html', data);// crm标签集合
export const apiStatisticscrmdatatow = data => mianApiPost('/statistics/crmdatatow.html', data);// crm标签集合
export const apiStatisticscrmdatatowss = data => mianApiPost('/statistics/crmdatatowss.html', data);// crm标签集合
export const apiStatisticscrmdatashoucifenpei = data => mianApiPost('/statistics/shoucifenpei.html', data);// crm标签集合

export const apiStatisticscrmdatathree = data => mianApiPost('/statistics/crmdatathree.html', data);// crm标签集合
export const apiStatisticscrmdatafour = data => mianApiPost('/statistics/crmdatafour.html', data);// crm标签集合
export const apiStatisticscrmdatafive = data => mianApiPost('/statistics/crmdatafive.html', data);// crm标签集合
export const apiStatisticscrmdatahome = data => mianApiPost('/statistics/crmdatahome.html', data);// crm标签集合


export const apiCrmPactTrace = data => mianApiPost('/crmpacttrace/lists.html', data);// 跟进列表
export const apiCrmPactTracestore = data => mianApiPost('/crmpacttrace/store.html', data);// 跟进列表

export const apiCrmPactFiles = data => mianApiPost('/crmpactfiles/lists.html', data);// 跟进列表
export const apiCrmPactFilesStore = data => mianApiPost('/crmpactfiles/store.html', data);// 跟进列表
export const apiCrmPactFilesDel = data => mianApiPost('/crmpactfiles/del.html', data);// 跟进列表

export const apiCrmImport = data => mianApiPost('/import/import.html', data);// 跟进列表
export const apiCrmImportshow = data => mianApiPost('/import/show.html', data);// 跟进列表
export const apiUsertongshi = data => mianApiPost('/user/tongshi.html', data);// 我的同事
export const apiCrmviewcontact = data => mianApiPost('/crm/viewcontact.html', data);// 获取联系方式
export const apiStatisticsviewlogs = data => mianApiPost('/statistics/crmviewlogs.html', data);// 获取联系方式

export const apiViewlogs = data => mianApiPost('/crmdataviewlog/lists.html', data);// 获取联系方式
export const apiCrmmap = data => mianApiPost('/crm/map.html', data);// 客户推荐图谱
export const apiNodealls = data => mianApiPost('/node/alls.html', data);// 节点列表
export const apiSignbinding = data => mianApiPost('/signlog/binding.html', data);// 节点列表
export const apiSignfindtoken = data => mianApiPost('/signlog/findtoken.html', data);// 节点列表
export const apiSignmakeqrcode = data => mianApiPost('/signevent/makeqrcode.html', data);// 节点列表
export const apiExternalsign = data => mianApiPost('/external/sign.html', data);// 节点列表
export const apiExternalsigninfo = data => mianApiPost('/external/signevent.html', data);// 节点列表
export const apiCrmfinancedanwei = data => mianApiPost('/crmfinance/danwei.html', data);// 节点列表

export const apiSetmemoalert = data => mianApiPost('/statistics/setmemoalert.html', data);// 节点列表
export const apiSetmemo = data => mianApiPost('/statistics/setmemo.html', data);// 节点列表




// WEBPACK FOOTER //
// ./src/request/api.js